import './index.css'

import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { loadLocalShortlistState } from '@disco/state-management/actions/UserActions'
import { getUserId } from '@disco/state-management/selectors/user'

import { getShortlistBaseRoute } from 'utils/routing'

import { Button } from 'components/ui'
import ButtonContainer from 'components/ui/button-container'
import ContactUsLink from 'components/ui/contact-us-link'
import Text from 'components/ui/text'
import VerticalSpacer from 'components/ui/vertical-spacer'

const mapStateToProps = state => ({
  userId: getUserId(state),
})

const mapDispatchToProps = {
  loadLocalShortlistState,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type OwnProps = {
  error: string | null | undefined
}

type Props = PropsFromRedux & OwnProps

function ShortlistStackError({ userId, loadLocalShortlistState }: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const baseRoute = getShortlistBaseRoute(location)
  return (
    <div className="shortlist-stack-error">
      <div>
        <Text type="paragraph">
          There was an issue loading the items in your Playlist Creator. You can
          refresh to reload the Playlist Creator and your content, or you can
          clear the items in the Playlist Creator.
        </Text>
        <VerticalSpacer />
        <ButtonContainer className="button-container--spread button-container--full-width">
          <div>
            <Button
              appearance="primary"
              caption="Reload playlist creator"
              onClick={() => loadLocalShortlistState(userId)}
            />
          </div>
          <div>
            <Button
              appearance="danger"
              caption="Clear playlist creator"
              onClick={() => {
                navigate(`${baseRoute}/shortlists/confirm-reset`)
              }}
            />
          </div>
        </ButtonContainer>
        <VerticalSpacer />
        <Text type="paragraph">
          If you&#39;ve already tried refreshing and your Playlist Creator
          content still isn&#39;t loading,{' '}
          <ContactUsLink>contact us</ContactUsLink>.
        </Text>
      </div>
    </div>
  )
}

export default connector(ShortlistStackError)
